(function () {
    const isCustomerAccountPage = /(?:^|\/)account(?:\/|$)/.test(window.location.pathname);

    // ScrollTrigger refreshes can reset the scroll position in mobile Safari
    // when its browser chrome changes the viewport while scrolling.
    if (isCustomerAccountPage) {
        return;
    }

    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
        console.warn("[ManaHeader] GSAP or ScrollTrigger not loaded.");
        return;
    }

    gsap.registerPlugin(ScrollTrigger);
    const header = document.querySelector(".mana-header-section");
    const stickyHeader = document.querySelector(".sticky-header-container");
    const bar = document.querySelector(".announcement-bar--wrapper");
    const main = document.querySelector(".main-content");

    if (!header || !main) {
        console.warn("[ManaHeader] Missing .mana-header-section or .main-content");
        return;
    }

    // Set top margin immediately to prevent layout shift
    const earlyHeaderHeight = header.offsetHeight || 0;
    main.style.marginTop = `${earlyHeaderHeight}px`;

    function setupLayout() {
        const headerHeight = header.offsetHeight || 0;
        main.style.marginTop = `${headerHeight}px`;
    }

    function setupScrollAnim() {
        ScrollTrigger.getAll().forEach(t => t.kill());

        const barHeight = bar ? bar.offsetHeight : 0;
        const stickyHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
        const headerHeight = header.offsetHeight || 0;

        // Reset positions
        if (bar) gsap.set(bar, { y: 0 });
        if (stickyHeader) gsap.set(stickyHeader, { y: 0 });

        // Animate both elements together
        const moveElements = [bar, stickyHeader].filter(Boolean);

        moveElements.forEach(el => {
            gsap.to(el, {
                y: -barHeight,
                ease: "none",
                scrollTrigger: {
                    trigger: header,
                    start: "top+=1 top",
                    end: `+=${headerHeight}`,
                    scrub: true,
                    invalidateOnRefresh: true,
                    markers: false
                }
            });
        });
    }

    function init() {
        setupLayout();
        setupScrollAnim();

        let lastWidth = window.innerWidth;

        window.addEventListener("resize", () => {
            const newWidth = window.innerWidth;
            if (newWidth !== lastWidth) {
                lastWidth = newWidth;
                setupLayout();
                ScrollTrigger.refresh();
                setupScrollAnim();
            }
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
